import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectCreative } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class Slider {
    constructor(target, option) {
        this.target = target;
        this.option = option;
        this.swiperInstance;
        this.init();
    }

    init() {
        if (!this.target) return;

        this.swiperInstance = new Swiper(this.target, {
            ...this.option,
            modules: [Navigation, Pagination, Autoplay, EffectCreative],
            observer: true,
            observeParents: true,
        });
    }
}
